<template>
  <div>
		<v-dialog v-model="getRlImageFullSizeDialog.show" scrollable max-width="600px">
			<v-card>
				<v-card-title>
          <v-spacer />
          <v-icon @click="setRlImageFullSizeDialog({show: false})">close_fullscreen</v-icon>
				</v-card-title>
				<v-card-text>
						<v-img :src="getRlImageFullSizeDialog.imgUrl" max-width="600px" class="grey lighten-2" />
				</v-card-text>
				<v-card-actions>
				</v-card-actions>
      </v-card>
		</v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
    	'setRlImageFullSizeDialog' 
		])
  },
  computed: {
    ...mapGetters([
			'getRlImageFullSizeDialog'
    ])
  }
}
</script>